module.exports = __webpack_public_path__ + "media/5.fa25eec9.mp3";